class PincodeChecker extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[name="pincode"]');
    this.button = this.querySelector('.pincode-checker__button');
    this.result = this.querySelector('[data-pincode-result]');
    this.resultText = this.querySelector('[data-pincode-result-text]');
    this.iconError = this.querySelector('[data-pincode-icon-error]');
    this.iconSuccess = this.querySelector('[data-pincode-icon-success]');
    this.spinner = this.querySelector('.loading-overlay__spinner');
    this.pincodes = null;

    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  async getPincodes() {
    if (this.pincodes) return this.pincodes;
    const response = await fetch(this.dataset.jsonUrl);
    const data = await response.json();
    this.pincodes = new Set(data);
    return this.pincodes;
  }

  async onSubmit(event) {
    event.preventDefault();
    const value = this.input.value.trim();

    if (!/^\d{6}$/.test(value)) {
      this.showResult(this.dataset.invalidMessage, 'invalid');
      return;
    }

    this.setLoading(true);
    this.showResult(this.dataset.loadingMessage, 'loading');

    try {
      const pincodes = await this.getPincodes();
      if (pincodes.has(value)) {
        this.showResult(this.dataset.successMessage.replace('{pincode}', value), 'success');
      } else {
        this.showResult(this.dataset.errorMessage.replace('{pincode}', value), 'error');
      }
    } catch (error) {
      this.showResult(this.dataset.invalidMessage, 'error');
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    this.button.classList.toggle('loading', isLoading);
    this.button.disabled = isLoading;
    this.spinner.classList.toggle('hidden', !isLoading);
  }

  showResult(message, state) {
    this.resultText.textContent = message;
    this.result.dataset.state = state;
    this.result.hidden = false;
    this.iconError.hidden = state !== 'error' && state !== 'invalid';
    this.iconSuccess.hidden = state !== 'success';
  }
}

customElements.define('pincode-checker', PincodeChecker);
